// Единая модель переменных для подсказки при вводе, ПКМ и правой панели.
export function buildFormulaParamItems(params = []) {
  return params
    .filter((param) => param?.code)
    .map((param) => {
      const isSource = !!param.source;
      const isCalculated = param.param_type === "calculated";
      const hint = isSource
        ? "Данные приложения"
        : isCalculated
          ? "Расчётный"
          : "Значение";

      return {
        key: `param-${param.local_id || param.code}`,
        code: param.code,
        label: param.name || param.code,
        hint,
        preview: hint,
        paramType: param.param_type || "value",
        // Тип цвета не выводим из `paramType`: данные приложения визуально
        // остаются отдельной категорией, хотя вычисляются как обычное значение.
        colorType: isSource
          ? "source"
          : isCalculated
            ? "calculated"
            : "value",
        type: isSource ? "source" : "param",
      };
    });
}

// Единая модель чипов нужна не только для цвета, но и для tooltip: параметр,
// привязанный к данным приложения, должен показывать человеку имя источника.
export function buildFormulaTokenLabels(params = []) {
  const sourceLabels = params.reduce((labels, param) => {
    if (param?.source && param.code === param.source) {
      labels[param.code] = param.name || param.code;
    }
    return labels;
  }, {});

  return params.reduce((labels, param) => {
    if (!param?.code) return labels;
    const sourceCode = param.source || null;

    labels[param.code] = {
      label: param.name || param.code,
      paramType: param.param_type || "value",
      source: !!sourceCode,
      sourceCode,
      sourceLabel: sourceCode
        ? sourceLabels[sourceCode] || sourceCode
        : null,
      defaultValue: param.default_value,
      formula: param.formula,
    };
    return labels;
  }, {});
}

export function filterFormulaTokenItems(items = [], query = "", limit = Infinity) {
  const normalizedQuery = String(query).trim().toLowerCase();
  if (!normalizedQuery) return items.slice(0, limit);

  return items
    .map((item, index) => {
      const label = String(item.label || "").toLowerCase();
      const code = String(item.code || "").toLowerCase();
      const hint = String(item.hint || item.preview || "").toLowerCase();
      let rank = Infinity;
      if (label.startsWith(normalizedQuery)) rank = 0;
      else if (code.startsWith(normalizedQuery)) rank = 1;
      else if (label.includes(normalizedQuery)) rank = 2;
      else if (code.includes(normalizedQuery)) rank = 3;
      else if (hint.includes(normalizedQuery)) rank = 4;
      return { item, index, rank };
    })
    .filter(({ rank }) => Number.isFinite(rank))
    .sort((left, right) => left.rank - right.rank || left.index - right.index)
    .slice(0, limit)
    .map(({ item }) => item);
}
